module.exports = __webpack_public_path__ + "img/klarna-ratenkauf.3d358939.png";